import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProjectCommissionMatrixHIReducer } from '../reducers';

export const selectProjectCommissionMatrixHIFeature = createFeatureSelector<ProjectCommissionMatrixHIReducer.DataState>(ProjectCommissionMatrixHIReducer.featureName);

export const selectFeatureProjectCommissionMatrix = createSelector(
  selectProjectCommissionMatrixHIFeature,
  (state: ProjectCommissionMatrixHIReducer.DataState) => state.detail
);
